// extracted by mini-css-extract-plugin
module.exports = {"statusTag":"statusTag_statusTag__2qEb3"};